package one.healthium.reminders.ui

import co.touchlab.kermit.Logger
import one.healthium.reminders.domain.RemindersInteractor
import one.healthium.ui.common.vm.BaseViewModel
import one.primehealth.app.BaseAppConfig

internal class RemindersViewModel(
    private val remindersInteractor: RemindersInteractor,
    private val baseAppConfig: BaseAppConfig,
) : BaseViewModel() {

    fun scheduleEvents() {
        if (baseAppConfig.features.remindersEnabled().not()) return

        launch {
            try {
                remindersInteractor.setupReminders()
            } catch (e: Exception) {
                Logger.e("Error scheduling reminders", e)
            }
        }
    }
}